module.exports = __webpack_public_path__ + "16b2bdd3a19e5c21285d8c480aba03cb.svg";